import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcFavoriteFillAccentshadow(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E5000F",
    d: "M20.272 5.785a5.237 5.237 0 0 0-7.405 0L12 6.65l-.866-.866a5.237 5.237 0 0 0-7.406 0c-1.868 1.868-2.058 4.84-.356 6.86.958 1.138 1.996 2.32 2.851 3.175 1.366 1.367 3.197 2.83 4.426 3.768.4.306.883.428 1.351.378.468.05.951-.072 1.351-.378 1.229-.939 3.06-2.402 4.426-3.768.855-.855 1.893-2.037 2.851-3.174 1.703-2.02 1.512-4.993-.356-6.861"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M19.742 6.315a4.487 4.487 0 0 0-6.345 0l-.867.867a.75.75 0 0 1-1.06 0l-.867-.867a4.487 4.487 0 0 0-6.345 0c-1.605 1.605-1.753 4.138-.313 5.847.955 1.134 1.976 2.296 2.809 3.128 1.329 1.33 3.127 2.767 4.35 3.703.242.184.532.258.817.227a.8.8 0 0 1 .159 0c.284.03.575-.043.816-.227 1.223-.936 3.021-2.374 4.35-3.703.833-.832 1.854-1.994 2.809-3.128 1.44-1.709 1.292-4.242-.313-5.847m-7.406-1.06a5.987 5.987 0 0 1 8.466 0c2.131 2.13 2.364 5.542.4 7.874-.961 1.14-2.016 2.343-2.895 3.222-1.403 1.403-3.266 2.89-4.5 3.833-.536.41-1.18.583-1.807.535a2.63 2.63 0 0 1-1.807-.535c-1.234-.943-3.097-2.43-4.5-3.833-.88-.88-1.934-2.081-2.895-3.222-1.964-2.332-1.731-5.744.4-7.875a5.987 5.987 0 0 1 8.466 0l.336.337z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 25.594,
    height: 21.726,
    x: -0.797,
    y: 3.251,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_68238_3536"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_68238_3536",
    result: "effect2_dropShadow_68238_3536"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_68238_3536",
    result: "shape"
  }))));
}
var IcFavoriteFillAccentshadow = createNolIcon(/*#__PURE__*/forwardRef(SvgIcFavoriteFillAccentshadow));

export { IcFavoriteFillAccentshadow as I };
